export default __webpack_public_path__ + "static/media/help-circle.643c97fc.svg";